import {Fragment} from 'react';
import {connect} from 'react-redux';
import {Button, Segment, Table} from 'semantic-ui-react';
import {startStudentCourse} from '../../redux/actions/student-course';

function StartStudentCourse(props) {
  return (
    <Segment textAlign='center'>
      {(props.createdStudentCourses.length > 0) ? (
        <Fragment>
          <Table celled striped collapsing unstackable textAlign='center' className='mx-auto'>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>نام دوره</Table.HeaderCell>
                <Table.HeaderCell>عملیات</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {props.createdStudentCourses.map(({id, name}) => (
                <Table.Row key={id}>
                  <Table.Cell>{name}</Table.Cell>
                  <Table.Cell>
                    <Button
                      positive
                      content='شروع'
                      onClick={props.startStudentCourse.bind(null, id)}
                    />
                  </Table.Cell>
                </Table.Row>
              ))
              }
            </Table.Body>
          </Table>
          <p>داوطلب گرامی با فشردن دکمه شروع می‌توانید هرکدام از دوره‌های آموزشی بالا را فعال کنید.</p>
        </Fragment>
      ) : (
        <p>داوطلب گرامی در حال حاضر دوره آموزشی برای شروع در سیستم وجود ندارد.</p>
      )}
    </Segment>
  );
}

export default connect(null, {startStudentCourse})(StartStudentCourse);
